import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTraApi {
  name: string;
  api_token: string;
}

export interface CuocDieuTraApiDetaiInfor {
  errors: unknown;
  CuocDieuTraApi: CuocDieuTraApi;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraApiDetail
  extends VuexModule
  implements CuocDieuTraApiDetaiInfor
{
  errors = {};
  CuocDieuTraApi = {} as CuocDieuTraApi;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get CuocDieuTraApiDetail() {
    return this.cuocDieuTraApiDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_API_DETAIL_DATA](CuocDieuTraApi) {
    this.cuocDieuTraApiDetailData = CuocDieuTraApi;
  }
  @Action
  [Actions.CUOC_DIEU_TRA_API_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/cuocdieutra_api",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.CUOC_DIEU_TRA_API_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
